/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdatePalReauthEmrDocumentSelectionRequest
 */
export interface UpdatePalReauthEmrDocumentSelectionRequest {
    /**
     * 
     */
    is_selected: boolean;
}

/**
 * Check if a given object implements the UpdatePalReauthEmrDocumentSelectionRequest interface.
 */
export function instanceOfUpdatePalReauthEmrDocumentSelectionRequest(value: object): value is UpdatePalReauthEmrDocumentSelectionRequest {
    if (!('is_selected' in value) || value['is_selected'] === undefined) return false;
    return true;
}

export function UpdatePalReauthEmrDocumentSelectionRequestFromJSON(json: any): UpdatePalReauthEmrDocumentSelectionRequest {
    return UpdatePalReauthEmrDocumentSelectionRequestFromJSONTyped(json, false);
}

export function UpdatePalReauthEmrDocumentSelectionRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdatePalReauthEmrDocumentSelectionRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'is_selected': json['is_selected'],
    };
}

export function UpdatePalReauthEmrDocumentSelectionRequestToJSON(json: any): UpdatePalReauthEmrDocumentSelectionRequest {
    return UpdatePalReauthEmrDocumentSelectionRequestToJSONTyped(json, false);
}

export function UpdatePalReauthEmrDocumentSelectionRequestToJSONTyped(value?: UpdatePalReauthEmrDocumentSelectionRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'is_selected': value['is_selected'],
    };
}

